export default "__VITE_ASSET__CSSxNYpM__"